export default "__VITE_ASSET__UX7ZKQjd__"